import { userPreferencesFavoriteSearchApi } from '@/main/api';
import { RoutesConstants } from "@/main/routes/routesConstants";
import { isEmpty } from '@/main/services/utils';
import { z } from "zod";

export const KeyValueSchema = z.object({
  key: z.union([z.string(), z.number()]),
  value: z.string(),
});

export const formSchema = z.object({
  quoteFilterVehicle: z.string().optional(),
  idQuoteStatus: z.array(KeyValueSchema).optional(),
  states: z.array(KeyValueSchema).optional(),
  reason: KeyValueSchema.nullable().optional(),
  insurer: KeyValueSchema.nullable().optional(),
  supplier: KeyValueSchema.nullable().optional(),
  bodyshopBranches: z.array(KeyValueSchema).optional(),
  subModel: z.string().optional(),
  vehicleManufacturer: z.string().optional(),
  vehicleModel: z.string().optional(),
  vehicle: z.string().optional(),
  idPreQuoteType: KeyValueSchema.nullable().optional(),
  havingItemCanceledBySupplier: z.boolean().optional(),
  sortByOldest:  KeyValueSchema.nullable().optional(),
});

export type TypeFavoriteSearchOrder = z.infer<typeof formSchema>;

export function mapFavoriteToForm(data: any): TypeFavoriteSearchOrder {
  return {
    quoteFilterVehicle: data.quoteFilterVehicle ?? "",
    idQuoteStatus: data.idQuoteStatus ?? [],
    states: data.states ?? [],
    insurer: data.insurer ?? null,
    supplier: data.supplier ?? null,
    bodyshopBranches: data.bodyshopBranches ?? [],
    subModel: data.subModel ?? "",
    vehicleManufacturer: data.vehicleManufacturer ?? "",
    vehicleModel: data.vehicleModel ?? "",
    vehicle: data.vehicle ?? "",
    idPreQuoteType: data.idPreQuoteType ?? null,
    havingItemCanceledBySupplier: !!data.havingItemCanceledBySupplier,
    sortByOldest: data.sortByOldest ?? null,
  };
}


export async function saveFavoriteSearch( data: TypeFavoriteSearchOrder | null): Promise<boolean> {
  try {
    await userPreferencesFavoriteSearchApi.saveUserPreferencesFavoriteSearch({
      routeUrl: RoutesConstants.orderSearchOrder,
      jsonData: data ? JSON.stringify(data) : "",
    });

    return true;
  } catch {
    return false;
  }
}


export async function getFavoriteSearch(): Promise<TypeFavoriteSearchOrder | null> {
  try {
    const response = await userPreferencesFavoriteSearchApi.getUserPreferencesFavoriteSearch<any>(
      RoutesConstants.orderSearchOrder
    );

    if (isEmpty(response?.data?.result)) return null;

    return mapFavoriteToForm(response.data.result);
  } catch {
    return null;
  }
}

export type TypePredefinedSearch = z.infer<typeof formSchema>;

export function mapPredefinedSearchToForm(data: any): TypePredefinedSearch {
  return {
    quoteFilterVehicle: data.quoteFilterVehicle ?? "",
    idQuoteStatus: data.idQuoteStatus ??[],
    states: data.states ?? [],
    insurer: data.insurer ?? null,
    supplier: data.supplier ?? null,
    bodyshopBranches: data.bodyshopBranches ?? [],
    subModel: data.subModel ?? "",
    vehicleManufacturer: data.vehicleManufacturer ?? "",
    vehicleModel: data.vehicleModel ?? "",
    vehicle: data.vehicle ?? "",
    idPreQuoteType: data.idPreQuoteType ?? null,
    havingItemCanceledBySupplier: !!data.havingItemCanceledBySupplier,
    sortByOldest: data.sortByOldest ?? null,
  };
}


export async function saveUserPredefinedSearch( data: TypePredefinedSearch | null, description: string
): Promise<boolean> {

  try {
    await userPreferencesFavoriteSearchApi.saveUserPredefinedSearch({
      routeUrl: RoutesConstants.orderSearchOrder,
      jsonData: data ? JSON.stringify(data) : "",
      description
    });

    return true;
  } catch {
    return false;
  }
}

export async function getDetailsUserPredefinedSearch(guidUserPredefinedSearch: string): Promise<TypePredefinedSearch | null> {
  try {
    const response = await userPreferencesFavoriteSearchApi.getDetailsUserPredefinedSearch<any>(
      guidUserPredefinedSearch
    );

    if (response?.data?.result) {
      return mapPredefinedSearchToForm(response.data.result);
    }

    return null;

  } catch {
    return null;
  }
}

export async function deleteUserPredefinedSearch( guidUserPredefinedSearch: string ): Promise<boolean>  {
  try {
    const response = await userPreferencesFavoriteSearchApi.deleteUserPredefinedSearch(
      guidUserPredefinedSearch
    );
    return true;
  } catch {
    return false;
  }
}